import React, { Component } from 'react';

/**
 * Component that alerts if you click outside of it
 */
export default class OutsideClickHandlerComponent extends Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);

    this.wrapperRef = null;
    this.touchStartTime = 0;
    this.ignoreClick = false;
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('touchstart', this.handleTouchStart, { passive: true });
    document.addEventListener('touchend', this.handleTouchEnd, { passive: true });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('touchstart', this.handleTouchStart);
    document.removeEventListener('touchend', this.handleTouchEnd);
  }

  handleTouchStart() {
    this.touchStartTime = Date.now();
  }

  handleTouchEnd() {
    const touchDuration = Date.now() - this.touchStartTime;
    this.ignoreClick = touchDuration > 200;
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    // in case we have some touch events it shouldn't trigger the click event
    if (this.ignoreClick) {
      this.ignoreClick = false;
      return;
    }

    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      if (this.props.onOutsideClick) this.props.onOutsideClick();
    }
  }

  render() {
    return <div id="input-formatting-menu" ref={this.setWrapperRef} className={this.props.className} style={this.props.style}>{this.props.children}</div>;
  }
}
